<template>
    <v-row class="ma-0 pb-offset">
        <v-col cols="12" class="pa-0">
            <v-card class="flex pa-0 background-2 round-card">
                <v-card-title class="pa-3">
				    <p class="pl-3">Impostazioni</p>
                    <v-spacer></v-spacer>
                </v-card-title>                
                <v-divider></v-divider>
                <v-list three-line subheader class="background-2 pa-2">
                    <v-subheader>Commissioni</v-subheader>
                    <v-list-item>
                        <v-list-item-action>
                            <v-checkbox color="primary" v-model="settings['commissions']"></v-checkbox>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>Calcolo provvigioni</v-list-item-title>
                            <v-list-item-subtitle>Attiva il calcolo delle provvigioni e mostra i campi relativi
                            </v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                    
                    <!-- <v-list-item>
                        <v-list-item-action>
                            <v-checkbox color="primary" v-model="settings['commission_with_expirations']"></v-checkbox>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>Calcolo provvigioni su Scadenze</v-list-item-title>
                            <v-list-item-subtitle>Calcola le provvigioni in base alle scadenze generate dal termine di pagamento del documento
                            </v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item> -->

                    <v-list-item>
                        <v-list-item-content style="height: 90px; padding-top: 24px;">
                            <v-col class="col-6">
                                <v-text-field
                                    label="Proviggione globale fissa"
                                    v-model="settings['fixed_commission']"
                                    type="number"
                                    required
                                    outlined
                                    dense
                                ></v-text-field>   
                            </v-col>
                            <!-- <v-col class="col-6">
                                <v-select
                                    label="Base di calcolo"
                                    :items="[{'text': 'Imponibile', 'value': 'subtotal'}, {'text': 'Totale', 'value': 'total'}]"
                                    v-model="settings['base_of_calculation']"
                                    :menu-props="{'offset-y': true}"
                                    outlined
                                    dense
                                ></v-select>   
                            </v-col> -->
                        </v-list-item-content>
                    </v-list-item>
                </v-list>

                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text class="pa-2 mx-3" color="primary" @click.native="saveSettings">Salva</v-btn>
                </v-card-actions>

            </v-card>
        </v-col>
    </v-row>
</template>

<script>
	import SettingsOptionsMixin from '@/mixins/SettingsOptionsMixin.js';

    export default {
        name: 'commissions-setting',
		mixins: [SettingsOptionsMixin],
        props: {},
        data() {
            return {
                model: 'agents',
                settings: {
                    'commissions': false,
                    'fixed_commission': 0,
                    'base_of_calculation': 'subtotal',
                },
                loading: false,
            }
        },

        methods: {

        },

    }
</script>